// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Home-Aside-index-root-1XLgz","advertisement":"src-components-Home-Aside-index-advertisement-2p_aA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home/Aside/index.css
 ** module id = 125
 ** module chunks = 0
 **/